"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterEmptyData = void 0;
const filterEmptyData = data => data.filter(item => Boolean(item.src));
exports.filterEmptyData = filterEmptyData;
//# sourceMappingURL=filterEmptyData.js.map